export enum HorizontalAlignmentType {
    LEFT = "left",
    RIGHT = "right",
    CENTER = "center"
}
export enum VerticalAlignmentType {
    TOP = "top",
    BOTTOM = "bottom",
    CENTER = "center"
}
